import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import MobileNav from "@/components/MobileNav";
import logo from "@/assets/ulc-logo.svg";
import { trackFBEvent } from "@/lib/fbPixel";

interface ScrollHeaderProps {
  currentPage?: string;
}

const ScrollHeader = ({ currentPage }: ScrollHeaderProps) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        setScrolled((prev) => {
          const next = window.scrollY > 50;
          return prev === next ? prev : next;
        });
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-white/80 backdrop-blur-md"
      }`}
    >
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="ULC World" className="h-10" width={115} height={40} />
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`transition-colors ${
              currentPage === "home" ? "text-primary font-medium" : "text-foreground/80 hover:text-foreground"
            }`}
          >
            Home
          </Link>
          <Link
            to="/courses"
            className={`transition-colors ${
              currentPage === "courses" ? "text-primary font-medium" : "text-foreground/80 hover:text-foreground"
            }`}
          >
            Courses
          </Link>
          <Link
            to="/immigration-services"
            className={`transition-colors ${
              currentPage === "immigration" ? "text-primary font-medium" : "text-foreground/80 hover:text-foreground"
            }`}
          >
            Immigration Services
          </Link>
          <Link
            to="/about"
            className={`transition-colors ${
              currentPage === "about" ? "text-primary font-medium" : "text-foreground/80 hover:text-foreground"
            }`}
          >
            About Us
          </Link>
          <Link
            to="/contact"
            className={`transition-colors ${
              currentPage === "contact" ? "text-primary font-medium" : "text-foreground/80 hover:text-foreground"
            }`}
          >
            Contact
          </Link>
          <Link
            to="/news"
            className={`transition-colors ${
              currentPage === "news" ? "text-primary font-medium" : "text-foreground/80 hover:text-foreground"
            }`}
          >
            News
          </Link>
          <Link
            to="/register"
            onClick={() => {
              trackFBEvent("ViewContent", {
                content_name: "Header Register Button",
                content_category: "Registration",
              });
            }}
          >
            <Button
              size="sm"
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-5 animate-[pulse_3s_ease-in-out_infinite] hover:animate-none"
            >
              Register Now
            </Button>
          </Link>
        </nav>
        <MobileNav />
      </div>
    </header>
  );
};

export default ScrollHeader;
